<button *ngIf="!mobile"  class="btn btn-primary" (click)="goBack()">
    <i class="fas fa-angle-left"></i> Back
</button>
<span *ngIf="mobile" (click)="goBack()" ><strong><i class="fas fa-angle-left"></i> BACK TO PREVIOUS PAGE</strong></span>
